var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.element.options !== null &&
    _vm.element.options.attrs !== null &&
    _vm.show
    ? _c(
        _vm.mode,
        {
          ref: "deSelect",
          tag: "component",
          attrs: {
            "class-id":
              "visual-" +
              _vm.element.id +
              "-" +
              _vm.inDraw +
              "-" +
              _vm.inScreen,
            "collapse-tags": _vm.showNumber,
            clearable: !_vm.element.options.attrs.multiple,
            multiple: _vm.element.options.attrs.multiple,
            placeholder:
              _vm.$t(_vm.element.options.attrs.placeholder) +
              _vm.placeholderSuffix,
            "popper-append-to-body": _vm.inScreen,
            size: _vm.size,
            filterable: true,
            "filter-method": _vm.filterMethod,
            "key-word": _vm.keyWord,
            "popper-class": "coustom-de-select",
            list: _vm.data,
            "custom-style": _vm.customStyle,
          },
          on: {
            change: _vm.changeValue,
            focus: _vm.setOptionWidth,
            blur: _vm.onBlur,
            "visual-change": _vm.visualChange,
            handleShowNumber: _vm.handleShowNumber,
          },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        _vm._l(_vm.templateData || _vm.data, function (item) {
          return _c(
            "el-option",
            {
              key: item[_vm.element.options.attrs.key],
              style: { width: _vm.selectOptionWidth },
              attrs: {
                label: item[_vm.element.options.attrs.label],
                value: item[_vm.element.options.attrs.value],
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "100%",
                    "white-space": "nowrap",
                    "text-overflow": "ellipsis",
                    overflow: "hidden",
                  },
                  attrs: { title: item[_vm.element.options.attrs.label] },
                },
                [_vm._v(_vm._s(item[_vm.element.options.attrs.label]))]
              ),
            ]
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }